// extracted by mini-css-extract-plugin
export default {"root":"_1PjS2","content":"_1-Yds","noDataPic":"_2I3y6","title":"_2KoPO"};